/* NUVA — reproductor de música ambiente (sitio completo)
   ----------------------------------------------------------------
   Arranca SIEMPRE silenciado (los navegadores nunca permiten sonido
   automático sin interacción previa) e intenta reanudar el sonido en
   la siguiente página si el cliente ya lo había activado antes,
   guardando esa preferencia en localStorage. El ícono nunca miente:
   siempre refleja el estado real de audio.muted/paused, nunca lo que
   "debería" pasar si el navegador bloqueó el intento. */
(function () {
  'use strict';

  var STORAGE_KEY = 'nuva:music:unmuted';

  function getStoredPreference() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }
  function storePreference(unmuted) {
    try { localStorage.setItem(STORAGE_KEY, unmuted ? '1' : '0'); } catch (e) { /* no-op */ }
  }

  function initPlayer(root) {
    if (root._nuvaMusicInit) return;
    root._nuvaMusicInit = true;

    var audio = root.querySelector('[data-nuva-music-audio]');
    var btn = root.querySelector('[data-nuva-music-toggle]');
    var iconOn = root.querySelector('[data-nuva-music-icon-on]');
    var iconOff = root.querySelector('[data-nuva-music-icon-off]');
    if (!audio || !btn) return;

    function reflectState() {
      var isUnmuted = !audio.muted && !audio.paused;
      btn.setAttribute('aria-pressed', isUnmuted ? 'true' : 'false');
      btn.setAttribute('aria-label', isUnmuted ? 'Silenciar música' : 'Activar música');
      if (iconOn) iconOn.hidden = !isUnmuted;
      if (iconOff) iconOff.hidden = isUnmuted;
    }

    // Autoplay silenciado: los navegadores siempre lo permiten.
    audio.play().catch(function () {
      /* incluso silenciado, algún navegador puede bloquearlo — no pasa
         nada, el botón de activar sigue funcionando con la interacción
         del cliente. */
    });

    // Si el cliente ya había activado el sonido en una página anterior,
    // intentamos reanudarlo con sonido — pero nunca asumimos que
    // funcionó: si el navegador lo bloquea, volvemos a silenciar y el
    // ícono refleja eso, nunca un estado falso de "sonando".
    if (getStoredPreference()) {
      audio.muted = false;
      var attempt = audio.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          audio.muted = true;
          storePreference(false);
          reflectState();
        });
      }
    }

    reflectState();

    btn.addEventListener('click', function () {
      if (audio.muted || audio.paused) {
        audio.muted = false;
        audio.play().then(function () {
          storePreference(true);
          reflectState();
        }).catch(function () {
          audio.muted = true;
          reflectState();
        });
      } else {
        audio.muted = true;
        storePreference(false);
        reflectState();
      }
    });

    // Si el estado cambia por otra vía (control del sistema, otra
    // pestaña), el ícono se mantiene sincronizado con la realidad.
    audio.addEventListener('play', reflectState);
    audio.addEventListener('pause', reflectState);
    audio.addEventListener('volumechange', reflectState);
  }

  document.querySelectorAll('[data-nuva-music-player]').forEach(initPlayer);

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-nuva-music-player]');
    if (root) initPlayer(root);
  });
})();
